import { Component, Input } from '@angular/core';

import { SearchActivityEvents } from 'generated/graphql';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

@Component({
  selector: 'app-mass-complete-follow-up-event',
  templateUrl: './mass-complete-follow-up-event.component.html'
})
export class ASMassCompleteFollowUpEventComponent extends
  WithDisposableSubject()  {

  @Input() item: SearchActivityEvents.Node;

  get payload() {
    return this.item?.payload;
  }

  /**
   *
   */
  constructor() {
    super();
  }
}
